import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  addPhoneNumberFormDefaultValues,
  addPhoneNumberFormSchema,
  IAddPhoneNumberFormModel,
} from "../models/addPhoneNumberFormModel";
import { useFormValidationMessages } from "../../../infrastructure/hooks/useFormHelper";

export const useAddPhoneNumberForm = () => {
  const form = useForm<IAddPhoneNumberFormModel>({
    defaultValues: addPhoneNumberFormDefaultValues,
    resolver: yupResolver(addPhoneNumberFormSchema),
  });

  useFormValidationMessages<IAddPhoneNumberFormModel>(form);

  return form;
};
